import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_CONTACTS_ACTION_TYPE } from '../actions';

const initialState = {
  contacts: [],
  contactsView: [],
};

const loanContactsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_CONTACTS_ACTION_TYPE.GET_LOAN_CONTACTS:
        draft.contacts = payload || initialState.contacts;
        break;

      case LOAN_CONTACTS_ACTION_TYPE.GET_LOAN_CONTACTS_VIEW:
        draft.contactsView = payload || initialState.contactsView;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanContactsReducer;
